// Domain
const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.orchestratorComponent.error.uncategorized.';

const DESCRIPTION = `${DOMAIN}description`,
  TITLE = `${DOMAIN}title`,
  ORDER_STATUS = `${DOMAIN}orderStatus`;

export { DESCRIPTION, ORDER_STATUS, TITLE };
